import { useAdmin } from '@vtex/raccoon-next'
import type { LogType } from '../typings/logger'

export function useLogger() {
  const { account, production, workspace } = useAdmin()

  function logger(params: LogType) {
    const { level, type, metadata, message } = params

    fetch('/api/logger', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        level,
        metadata,
        type,
        account,
        workspace,
        production,
        message,
      }),
    })
  }

  return {
    logger,
  }
}
